import { alpha, Theme } from "@mui/material";

export const getInputOverrides = (theme: Theme) => ({
  MuiTextField: {
    styleOverrides: {
      root: {
        marginBottom: "0px !important",
        color: "#1D1D1D",
        "& .MuiFormLabel-root-MuiInputLabel-root.Mui-focused": {
          color: theme.palette.highlight,
        },
        "& .MuiOutlinedInput-root": {
          "& fieldset": {
            borderColor: theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.23) !important" : "#ccc",
          },
          "&:hover fieldset": {
            borderColor: theme.palette.mode === "dark" ? "#FFFFFF !important" : theme.palette.highlight,
          },
          "&.Mui-focused fieldset": {
            borderColor: `${theme.palette.highlight} !important`,
          },
          "&.Mui-error fieldset": {
            borderColor: "#F44336",
          },
          "&.Mui-disabled fieldset": {
            borderColor: theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.12) !important" : "#E0E0E0",
          },
        },
        // MuiPickers styles integration
        "& .MuiPickersInputBase-root": {
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.23) !important" : "#ccc",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: theme.palette.mode === "dark" ? "#FFFFFF !important" : theme.palette.highlight,
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: theme.palette.highlight,
          },
        },
      },
    },
    defaultProps: { size: "small" },
  },
  MuiOutlinedInput: {
    styleOverrides: {
      input: {
        color: theme.palette.mode === "dark" ? "#FFFFFF" : "#1D1D1D",
        height: "25px",
        fontSize: "14px",
        padding: "10px 14px",
        display: "flex",
        alignItems: "center",
        "&.Mui-disabled": {
          backgroundColor: theme.palette.mode === "dark" ? "transparent" : undefined,
          color: theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.5)" : "#888",
          "-webkit-text-fill-color": theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.5)" : undefined,
        },
      },
      root: {
        "&.Mui-disabled": {
            backgroundColor: theme.palette.mode === "dark" ? "transparent" : alpha("#cccccc", 0.2),
            color: theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.5)" : "#888",
            borderColor: theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.3)" : "#ccc",
            "-webkit-text-fill-color": theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.5)" : undefined,
             "& .MuiOutlinedInput-notchedOutline": {
                borderColor: theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.3)" : "#ccc",
             },
        },
      },
    },
  },
  MuiInputLabel: {
    styleOverrides: {
      root: {
        color: theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.7)" : "#4A4A4A",
        "&.Mui-disabled": {
          color: theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.5)" : "#B0B0B0",
        },
        "&.Mui-focused": {
          color: theme.palette.highlight,
        },
        "&:not(.MuiInputLabel-shrink)": {
          transform: "translate(14px, 12px) scale(1)",
        },
      },
    },
  },
  MuiAutocomplete: {
    styleOverrides: {
      root: {
        "& .MuiOutlinedInput-root": {
          backgroundColor: theme.palette.mode === "dark" ? "transparent" : alpha("#FFFFFF", 0.08),
          color: theme.palette.mode === "dark" ? "#fff" : "#1D1D1D",
          borderRadius: 4,
        },
        "& fieldset": {
          borderColor: theme.palette.mode === "dark" ? "#aaa" : "#ccc",
        },
        "&:hover fieldset": {
          borderColor: theme.palette.mode === "dark" ? "#fff" : theme.palette.highlight,
        },
        "&.Mui-focused fieldset": {
          borderColor: theme.palette.highlight,
        },
        "&.Mui-disabled": {
          backgroundColor: theme.palette.mode === "dark" ? "transparent" : "#f1f1f1",
          color: theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.5)" : "#aaa",
        },
      },
    },
  },
});
